

import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Apiurl from "../environment/Apiurl";
import Image_Logo from "../../assets/images/Login.png";
import "../../assets/css/AttendanceCalendar.css";

function Report_Attendance_View() {
  const [value, onChange] = useState(new Date());
  const [attendanceData, setAttendanceData] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { staffId } = useParams();

  useEffect(() => {
    fetchAttendance();
  }, [staffId]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const fetchAttendance = async () => {
    try {
      const response = await axios.get(`${Apiurl}/attendance/${staffId}`);
      const uniqueAttendance = response.data.reduce((acc, current) => {
        const existing = acc.find((item) => item.date === current.date);
        if (!existing) {
          acc.push(current);
        }
        return acc;
      }, []);
      setAttendanceData(uniqueAttendance || []);
      setError(null);
    } catch (error) {
      console.error("Error fetching attendance", error);
      setError("Failed to load attendance data.");
      setAttendanceData([]);
    }
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const normalizeTime = (time) => {
    if (!time || time === "N/A" || time === "") return "N/A";
    if (time.includes("AM") || time.includes("PM")) {
      return time;
    }
    const [hours, minutes] = time.split(":");
    const hoursNum = parseInt(hours, 10);
    const period = hoursNum >= 12 ? "PM" : "AM";
    const normalizedHours = hoursNum % 12 || 12;
    return `${normalizedHours}:${minutes} ${period}`;
  };

  const getTileClassName = ({ date, view }) => {
    if (view !== "month") return "";

    const today = new Date();
    const isToday =
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear();

    const isCurrentMonth = date.getMonth() === value.getMonth();
    const formattedDate = formatDate(date);
    const data = attendanceData.find(
      (entry) => formatDate(entry.date) === formattedDate
    );

    let classes = "";

    if (isToday) {
      classes += "today-tile ";
    }

    if (!isCurrentMonth) {
      classes += "other-month-tile ";
    }

    const day = date.getDay();
    if (isCurrentMonth) {
      if (day === 0 || day === 6) {
        classes += "weekend-tile ";
      } else {
        switch (day) {
          case 1:
            classes += "monday-tile ";
            break;
          case 2:
            classes += "tuesday-tile ";
            break;
          case 3:
            classes += "wednesday-tile ";
            break;
          case 4:
            classes += "thursday-tile ";
            break;
          case 5:
            classes += "friday-tile ";
            break;
          default:
            break;
        }
      }
    }

    if (data) {
      return `${classes} tile-attendance`.trim();
    } else {
      const day = date.getDay();
      if (day === 0 || day === 6) {
        return `${classes} tile-weekoff`.trim();
      }
    }

    return classes.trim();
  };

  const getTileContent = ({ date, view }) => {
    if (view === "month") {
      const formattedDate = formatDate(date);
      const data = attendanceData.find(
        (entry) => formatDate(entry.date) === formattedDate
      );

      if (data) {
        const login = normalizeTime(data.login);
        const logout = normalizeTime(data.logout);
        return (
          <div className="tile-content">
            <span style={{ fontSize: "12px" }}>Login: {login}</span>
            <br />
            <span style={{ fontSize: "12px" }}>Logout: {logout}</span>
          </div>
        );
      } else {
        const day = date.getDay();

        return (
          <div className="tile-content weekoff">
            <span style={{ fontSize: "12px" }}>Weekoff</span>
          </div>
        );
      }
    }
    return null;
  };

  // const handleSubmit = () => {
  //   navigate("/hr-management/attendance");
  // };

  const handleSubmit = () => {
    navigate("/reports", {
      state: { active: "attendance" },
    });
  };

  const staffData = attendanceData[0]?.staffData || {};

  return (
    <div className="container-fluid">
      {error && (
        <div className="alert alert-danger text-center" role="alert">
          {error}
        </div>
      )}
      <div className="row">
        <div className="col-lg-3 col-md-3">
          <div className="card" style={{ marginTop: "20px" }}>
            <div className="d-flex justify-content-center align-items-center mt-3">
              <img
                src={Image_Logo}
                alt="Avatar"
                className="card-image"
                style={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                }}
              />
            </div>
            <div className="card-body">
              <p className="card bg-secondary text-white p-2 text-center fw-bold fs-5">
                {staffData.first_name} {staffData.last_name}
              </p>
              <p className="card bg-secondary text-white p-2 text-center fw-bold fs-5">
                {staffData.staff_id || "N/A"}
              </p>
              <p className="card bg-secondary text-white p-2 text-center fw-bold fs-5">
                {staffData.department || "N/A"}
              </p>
              <p className="card bg-secondary text-white p-2 text-center fw-bold fs-5">
                {staffData.designation_name || "N/A"}
              </p>
              <p className="card bg-secondary text-white p-2 text-center fw-bold fs-5">
                {staffData.mobile_no || "N/A"}
              </p>
            </div>
          </div>
        </div>

        <div className="col-lg-9 col-md-9">
          <div className="calendar-container">
            <div className="attendance-row attendance-mt-3">
              <div className="attendance-col-10">
                {attendanceData.length > 0 ? (
                  <Calendar
                    onChange={onChange}
                    value={value}
                    tileContent={getTileContent}
                    tileClassName={getTileClassName}
                  />
                ) : (
                  <p className="text-center text-muted">
                    No attendance data available.
                  </p>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center gap-2 mb-2">
            <button
              className="text-white mt-3 px-3 py-1 rounded-3"
              style={{ backgroundColor: "#01AEBE" }}
              onClick={handleSubmit}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Report_Attendance_View;
